import {
    SYSTEM_CHOOSE_CURRENT_COMPANYTYPE,
} from './constants';
  
export function chooseCurrentCompanyType(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_COMPANYTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_COMPANYTYPE:
        return {
          ...state,
          currentCompanyType:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentCompanyType.js